import React from "react";

export default function Save() {
    return (
      <div>
        <h1>Save</h1>
      </div>
    );
  }